/*
 * Copyright (c) 2023-2024 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */
import { Label, Nav, NavItem, NavLink } from "reactstrap";
import user_new from "../../assets/images/user_account_0_stars.png"
import user_returning from "../../assets/images/user_account_1_star.png"
import user_loyal from "../../assets/images/user_account_3_stars.png"

const OnlineOverlay = ({ color, top, left }) => {
  const circleStyle = {
    position: 'absolute',
    top: top,
    left: left,
    width: '25%',
    height: '25%',
    borderRadius: '50%',
    backgroundColor: color,
    zIndex: '1'
  };

  return <div style={circleStyle}></div>;
}

const GuestAvatar = ({ guest }) => {
  const avatarSize = "80";
  switch (guest?.loyaltyStatus) {
    case "loyal":
      return <img className="rounded-circle" width={avatarSize} src={user_loyal} alt="Profile" />;
    case "returning":
      return <img className="rounded-circle" width={avatarSize} src={user_returning} alt="Profile" />;
    default:
      return <img className="rounded-circle" width={avatarSize} src={user_new} alt="Profile" />;
  }
}

const GuestProfileNavigation = ({
  guest,
  navLinks,
  selected,
  onSelected,
}) => {

  return (
    <div className="ms-3 mt-3 d-flex align-items-start">
      <div style={{ position: 'relative', display:'inline-block'}}>
        <GuestAvatar guest={guest} />
        <OnlineOverlay color={guest.isOnline ? "#2C2" : "#C22"} top="0" left="0" />
      </div>
      <div>
      <Label className="ms-3 fw-bold" tag="h4">{guest.name}</Label>

        <Nav tabs className="mt-3 ms-3">
          {navLinks.map((item, index) => (
            <NavItem key={index}>
              <NavLink
                className="clickable"
                active={selected === item.id}
                onClick={() => onSelected?.(item.id)}
              >
                {item.name}
              </NavLink>
            </NavItem>
          ))}
        </Nav>     
      </div>
    </div>
  )
};

export default GuestProfileNavigation;
